import { render } from "./final_gradding.vue?vue&type=template&id=8bb763d8"
import script from "./final_gradding.vue?vue&type=script&lang=js"
export * from "./final_gradding.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__